// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__RW+-y","logo":"Sidebar_logo__PZeT-","userLogo":"Sidebar_userLogo__70RDP","userName":"Sidebar_userName__atB-o","logOut":"Sidebar_logOut__p4p+R"};